<template>
    <div v-if="this.locations.length > 0">
        <div class="col-md-12 pb-2 pl-0" v-if="!currentLocationIsOnboarded">
            <h3>Dealership Information</h3>
            <p class="text-dark">
                Please complete the following information that will be used to
                create your Dealer Commission Program account.
            </p>
        </div>
        <div class="row gap-3">
            <div class="col-md-5">
                <div class="row mt-2" v-if="locations.length > 1">
                    <div class="col-md-6 pb-2">
                        <div class="form-group">
                            <label class="text-muted"
                                >Select Your Location:
                            </label>
                            <div class="input-group">
                                <select
                                    class="form-control"
                                    v-model="locationId"
                                >
                                    <option value="">- Select -</option>
                                    <option
                                        v-for="(location, index) in locations"
                                        :key="index"
                                        :value="location.id"
                                    >
                                        {{ location.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div
                            class="invalid-feedback d-block"
                            v-if="errors.includes('locationId')"
                        >
                            Invalid Location
                        </div>
                    </div>
                </div>
                <div v-if="!currentLocationIsOnboarded">
                    <div class="row mt-2">
                        <div class="col-md-6 pb-2">
                            <div class="form-group">
                                <label class="text-muted">Company Name</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Company Name"
                                        autocomplete="off"
                                        v-model="company"
                                    />
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('company')"
                                    >
                                        Invalid Company Name
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6 pb-2">
                            <div class="form-group">
                                <label class="text-muted">First Name</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="First Name"
                                        autocomplete="off"
                                        v-model="firstName"
                                    />
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('firstName')"
                                    >
                                        Invalid First Name
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 pb-2">
                            <div class="form-group">
                                <label class="text-muted">Last Name</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Last Name"
                                        autocomplete="off"
                                        v-model="lastName"
                                    />
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('lastName')"
                                    >
                                        Invalid Last Name
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6 pb-2">
                            <div class="form-group">
                                <label class="text-muted">Email Address</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Email Address"
                                        autocomplete="off"
                                        v-model="emailAddress"
                                    />
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('emailAddress')"
                                    >
                                        Invalid Email
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 pb-2">
                            <div class="form-group">
                                <label class="text-muted">Phone Number</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Phone Number"
                                        autocomplete="off"
                                        v-model="phone"
                                        required
                                    />

                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('phone')"
                                    >
                                        Invalid Phone Number
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-12 pb-2">
                            <div class="form-group">
                                <label class="text-muted">Address Line 1</label>
                                <div class="input-group">
                                    <input
                                        type="email"
                                        class="form-control"
                                        placeholder="Address Line 1"
                                        autocomplete="off"
                                        v-model="address1"
                                    />
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('address1')"
                                    >
                                        Invalid Address
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-12 pb-2">
                            <div class="form-group">
                                <label class="text-muted">Address Line 2</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Address Line 2"
                                        autocomplete="off"
                                        v-model="address2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4 pb-2">
                            <div class="form-group">
                                <label class="text-muted">City</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="City"
                                        autocomplete="off"
                                        v-model="city"
                                    />

                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('city')"
                                    >
                                        Invalid City
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 pb-2">
                            <div class="form-group">
                                <label class="text-muted">State</label>
                                <div class="input-group">
                                    <select
                                        class="form-control"
                                        autocomplete="off"
                                        v-model="state"
                                        required
                                    >
                                        <option value="">Select state</option>
                                        <option value="ALABAMA">ALABAMA</option>
                                        <option value="ALASKA">ALASKA</option>
                                        <option value="ARIZONA">ARIZONA</option>
                                        <option value="ARKANSAS">
                                            ARKANSAS
                                        </option>
                                        <option value="CALIFORNIA">
                                            CALIFORNIA
                                        </option>
                                        <option value="COLORADO">
                                            COLORADO
                                        </option>
                                        <option value="CONNECTICUT">
                                            CONNECTICUT
                                        </option>
                                        <option value="DELAWARE">
                                            DELAWARE
                                        </option>
                                        <option value="FLORIDA">FLORIDA</option>
                                        <option value="GEORGIA">GEORGIA</option>
                                        <option value="HAWAII">HAWAII</option>
                                        <option value="IDAHO">IDAHO</option>
                                        <option value="ILLINOIS">
                                            ILLINOIS
                                        </option>
                                        <option value="INDIANA">INDIANA</option>
                                        <option value="IOWA">IOWA</option>
                                        <option value="KANSAS">KANSAS</option>
                                        <option value="KENTUCKY">
                                            KENTUCKY
                                        </option>
                                        <option value="LOUISIANA">
                                            LOUISIANA
                                        </option>
                                        <option value="MAINE">MAINE</option>
                                        <option value="MARYLAND">
                                            MARYLAND
                                        </option>
                                        <option value="MASSACHUSETTS">
                                            MASSACHUSETTS
                                        </option>
                                        <option value="MICHIGAN">
                                            MICHIGAN
                                        </option>
                                        <option value="MINNESOTA">
                                            MINNESOTA
                                        </option>
                                        <option value="MISSISSIPPI">
                                            MISSISSIPPI
                                        </option>
                                        <option value="MISSOURI">
                                            MISSOURI
                                        </option>
                                        <option value="MONTANA">MONTANA</option>
                                        <option value="NEBRASKA">
                                            NEBRASKA
                                        </option>
                                        <option value="NEVADA">NEVADA</option>
                                        <option value="NEW HAMPSHIRE">
                                            NEW HAMPSHIRE
                                        </option>
                                        <option value="NEW JERSEY">
                                            NEW JERSEY
                                        </option>
                                        <option value="NEW MEXICO">
                                            NEW MEXICO
                                        </option>
                                        <option value="NEW YORK">
                                            NEW YORK
                                        </option>
                                        <option value="NORTH CAROLINA">
                                            NORTH CAROLINA
                                        </option>
                                        <option value="NORTH DAKOTA">
                                            NORTH DAKOTA
                                        </option>
                                        <option value="OHIO">OHIO</option>
                                        <option value="OKLAHOMA">
                                            OKLAHOMA
                                        </option>
                                        <option value="OREGON">OREGON</option>
                                        <option value="PENNSYLVANIA">
                                            PENNSYLVANIA
                                        </option>
                                        <option value="RHODE ISLAND">
                                            RHODE ISLAND
                                        </option>
                                        <option value="SOUTH CAROLINA">
                                            SOUTH CAROLINA
                                        </option>
                                        <option value="SOUTH DAKOTA">
                                            SOUTH DAKOTA
                                        </option>
                                        <option value="TENNESSEE">
                                            TENNESSEE
                                        </option>
                                        <option value="TEXAS">TEXAS</option>
                                        <option value="UTAH">UTAH</option>
                                        <option value="VERMONT">VERMONT</option>
                                        <option value="VIRGINIA">
                                            VIRGINIA
                                        </option>
                                        <option value="WASHINGTON">
                                            WASHINGTON
                                        </option>
                                        <option value="WEST VIRGINIA">
                                            WEST VIRGINIA
                                        </option>
                                        <option value="WISCONSIN">
                                            WISCONSIN
                                        </option>
                                        <option value="WYOMING">WYOMING</option>
                                    </select>
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('state')"
                                    >
                                        Invalid State
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 pb-2">
                            <div class="form-group">
                                <label class="text-muted">Zip</label>
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Zip"
                                        autocomplete="off"
                                        v-model="zip"
                                        required
                                    />
                                    <div
                                        class="invalid-feedback d-block"
                                        v-if="errors.includes('zip')"
                                    >
                                        Invalid Zip
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6 pb-2">
                            <div class="form-group">
                                <label class="text-muted"
                                    >Tax Classification:
                                </label>
                                <div class="input-group">
                                    <select
                                        class="form-control"
                                        v-model="taxClassification"
                                    >
                                        <option value="">- Select -</option>
                                        <option value="Sole Proprietor">
                                            Sole Proprietor
                                        </option>
                                        <option value="C Corporation">
                                            C Corporation
                                        </option>
                                        <option value="S Corporation">
                                            S Corporation
                                        </option>
                                        <option value="Partnership">
                                            Partnership
                                        </option>
                                        <option value="Trust / Estate">
                                            Trust / Estate
                                        </option>
                                        <option value="LLC">LLC</option>
                                    </select>
                                </div>
                            </div>
                            <div
                                class="invalid-feedback d-block"
                                v-if="errors.includes('taxClassification')"
                            >
                                Invalid Tax Classification
                            </div>
                        </div>
                        <div class="col-md-6 pb-2">
                            <div class="form-group">
                                <label class="text-muted">
                                    Please upload a copy of your current W9
                                </label>
                                <div class="custom-file">
                                    <input
                                        type="file"
                                        name="file-upload"
                                        @change="onChange"
                                        class="custom-file-input"
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        id="customFile"
                                    />
                                    <label class="custom-file-label" for="customFile">
                                        Select File from your computer
                                    </label>
                                </div>
                                <label class="text-muted">
                                    *either the business name or DBA must match your FFL name
                                </label>
                                <div class="preview-container mt-2" v-if="files.length">
                                    <div
                                        v-for="file in files"
                                        :key="file.name"
                                        class="preview-card"
                                    >
                                        <img
                                            v-if="file.type == 'application/pdf'"
                                            class="preview-img"
                                            src="images/pdf.png"
                                        />
                                        <img
                                            v-else
                                            class="preview-img2"
                                            :src="generateURL(file)"
                                        />
                                        <span class="name">{{ file.name }}</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="invalid-feedback d-block"
                                v-if="errors.includes('copyOfW9')"
                            >
                                File is required
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-10 pb-2" style="color: black">
                            <div class="form-group">
                                <h4>Additional Services:</h4>
                                <small
                                    >Do you offer any of the below additional
                                    services at your shop for customers?
                                    SilencerCo will list these services to
                                    customers when customers select their
                                    dealer, increasing your chance of being
                                    selected over other dealers. Check all that
                                    apply:
                                </small>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <input
                                        type="checkbox"
                                        id="passport_photos"
                                        value="Passport Photos"
                                        class="mr-2"
                                        v-model="additionalServices"
                                    />
                                    <label for="passport_photos"
                                        >Passport Photos</label
                                    >
                                </div>
                                <div class="col-md-6">
                                    <input
                                        type="checkbox"
                                        id="fingerprint_cards"
                                        value="Fingerprint Cards"
                                        class="mr-2"
                                        v-model="additionalServices"
                                    />
                                    <label for="fingerprint_cards"
                                        >Fingerprint Cards</label
                                    >
                                </div>
                                <div class="col-md-6">
                                    <input
                                        type="checkbox"
                                        id="eft_fingerprints"
                                        value="EFT Fingerprints (Digital)"
                                        class="mr-2"
                                        v-model="additionalServices"
                                    />
                                    <label for="eft_fingerprints"
                                        >EFT Fingerprints (Digital)
                                    </label>
                                </div>

                                <div class="col-md-6">
                                    <input
                                        type="checkbox"
                                        id="eforms"
                                        value="eForms"
                                        class="mr-2"
                                        v-model="additionalServices"
                                    />
                                    <label for="eforms">eForms</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5" v-if="!currentLocationIsOnboarded">
                <div class="row mt-2">
                    <div class="col-md-10 pb-2 mt-4">
                        <p>
                            Please provide the bank information where you would
                            like your commissions deposited.
                        </p>
                        <div class="form-group">
                            <label class="text-muted">Bank Name</label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Bank Name"
                                    autocomplete="off"
                                    v-model="bankName"
                                />
                                <div
                                    class="invalid-feedback d-block"
                                    v-if="errors.includes('bankName')"
                                >
                                    Invalid Bank Name
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-10 pb-2">
                        <div class="form-group">
                            <label class="text-muted">Routing Number</label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Routing Number"
                                    autocomplete="off"
                                    v-model="routingNumber"
                                />
                                <div
                                    class="invalid-feedback d-block"
                                    v-if="errors.includes('routingNumber')"
                                >
                                    Invalid Routing Number
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-10 pb-2">
                        <div class="form-group">
                            <label class="text-muted">Account Number</label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Account Number"
                                    autocomplete="off"
                                    v-model="accountNumber"
                                    required
                                />
                                <div
                                    class="invalid-feedback d-block"
                                    v-if="errors.includes('accountNumber')"
                                >
                                    Invalid Account Number
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-10 pb-2">
                        <div class="form-group">
                            <label class="text-muted"
                                >Confirm Account Number</label
                            >
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Confirm Account Number"
                                    autocomplete="off"
                                    v-model="confirmAccountNumber"
                                    required
                                />
                                <div
                                    class="invalid-feedback d-block"
                                    v-if="
                                        errors.includes('confirmAccountNumber')
                                    "
                                >
                                    Account Number does not match
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-12">
                <input
                    type="checkbox"
                    id="sign_agreement"
                    value="Passport Photos"
                    class="mr-2"
                    v-model="signAgreement"
                />
                <label for="sign_agreement" class="sign_agreement">
                    *I understand and agree that I will not charge transfer fees to customers sent to me from SilencerCo.com as SilencerCo will pay me commissions for these sales.
                </label>
                <div
                    class="invalid-feedback d-block"
                    v-if="
                        errors.includes('signAgreement')
                    "
                >
                    This is required
                </div>
            </div>
        </div>
        <div class="row mt-5 text-center" v-if="!currentLocationIsOnboarded">
            <div class="col-md-10">
                <button
                    type="submit"
                    class="btn btn-outline-orange text-orange text-uppercase w-50"
                    @click="saveData"
                    v-if="!saving"
                >
                    Continue to Sign Agreement
                </button>
                <button
                    type="submit"
                    class="btn btn-danger text-white text-uppercase w-50 element-fadeinout"
                    v-else
                >
                    Saving
                </button>
            </div>
        </div>
        <div class="row mt-1 text-center" v-else>
            <div class="alert alert-success" role="alert">
                This Dealer is already registered on our Dealer Commission
                Program
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";
export default {
    props: ["id"],
    emits: ['save'],
    components: {},
    setup() {
        const store = useStore();
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        let user = computed(function () {
            return store.state.user;
        });

        return {
            store,
            user,
        };
    },
    data() {
        return {
            locationId: "",
            firstName: null,
            lastName: null,
            emailAddress: null,
            phone: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            zip: null,
            bankName: null,
            routingNumber: null,
            accountNumber: null,
            confirmAccountNumber: null,
            errors: [],
            locations: [],
            saving: false,
            company: null,
            taxClassification: "",
            additionalServices: [],
            files: [],
            signAgreement: false,
        };
    },
    created() {},
    mounted() {
        this.getLocations();
    },
    computed: {
        currentLocationIsOnboarded() {
            if (this.locationId != "" && this.locationId != null) {
                let index = this.locations.findIndex(
                    (item) => item.id == this.locationId
                );
                if (index != -1) {
                    if (
                        this.locations[index].direct_to_dealer_onboarding !=
                        null
                    ) {
                        if (
                            this.locations[index].direct_to_dealer_onboarding
                                .signing_session_data != null
                        ) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
    },
    watch: {
        locationId(newval, oldval) {
            if (newval != oldval) {
                this.populateFields();
            }
        },
    },
    methods: {
        getLocations() {
            axios
                .post("/api/get-locations", { user_id: this.user.id })
                .then((data) => {
                    this.locations = data.data.result;

                    console.log("id", this.id);
                    if (this.id != null && this.id != "") {
                        this.locationId = this.id;
                    } else {
                        if (data.data.result.length == 1) {
                            this.locationId = data.data.result[0].id;
                            this.populateFields();
                        }
                    }
                });
        },
        validateForm() {
            this.errors = [];
            if (this.locationId == "") {
                this.errors.push("locationId");
            }
            if (this.firstName == "" || this.firstName == null) {
                this.errors.push("firstName");
            }
            if (this.lastName == "" || this.lastName == null) {
                this.errors.push("lastName");
            }
            if (this.emailAddress == "" || this.emailAddress == null) {
                this.errors.push("emailAddress");
            }
            if (this.phone == "" || this.phone == null) {
                this.errors.push("phone");
            }
            if (this.address1 == "" || this.address1 == null) {
                this.errors.push("address1");
            }
            if (this.city == "" || this.city == null) {
                this.errors.push("city");
            }
            if (this.state == "" || this.state == null) {
                this.errors.push("state");
            }
            if (this.zip == "" || this.zip == null) {
                this.errors.push("zip");
            }
            if (this.bankName == "" || this.bankName == null) {
                this.errors.push("bankName");
            }
            if (this.routingNumber == "" || this.routingNumber == null) {
                this.errors.push("routingNumber");
            }
            if (this.accountNumber == "" || this.accountNumber == null) {
                this.errors.push("accountNumber");
            }
            if (this.company == "" || this.company == null) {
                this.errors.push("company");
            }
            if (
                this.confirmAccountNumber == "" ||
                this.confirmAccountNumber == null ||
                this.confirmAccountNumber != this.accountNumber
            ) {
                this.errors.push("confirmAccountNumber");
            }
            if (
                this.taxClassification == "" ||
                this.taxClassification == null
            ) {
                this.errors.push("taxClassification");
            }
            if (this.files.length == 0) {
                this.errors.push("copyOfW9");
            }
            if (this.signAgreement == false) {
                this.errors.push("signAgreement");
            }

            console.log(this.errors);
        },

        populateFields() {
            if (this.locationId != "" && this.locationId != null) {
                let index = this.locations.findIndex(
                    (item) => item.id == this.locationId
                );
                if (index != -1) {
                    this.firstName = this.user.first_name;
                    this.lastName = this.user.last_name;
                    this.emailAddress =
                        this.locations[index].email != null
                            ? this.locations[index].email
                            : this.user.email;
                    this.phone =
                        this.locations[index].phone != null
                            ? this.locations[index].phone
                            : this.user.phone;
                    this.address1 = this.locations[index].address;
                    this.address2 = this.locations[index].address_2;
                    this.city = this.locations[index].city;
                    this.state =
                        this.locations[index].state != null
                            ? this.locations[index].state.toUpperCase()
                            : "";
                    this.zip = this.locations[index].zip_code;
                    this.company = this.locations[index].name;
                }
            }
        },

        saveData() {
            this.validateForm();

            if (this.errors.length > 0) {
                return;
            }
            // this.$emit("save", { test: 1 });
            // this.errors = [];
            this.saving = true;

            var newFiles = [];
            newFiles.push(this.files[0]);

            axios
                .post("/api/save-initial-d2d-onboarding", {
                    location_id: this.locationId,
                    signed_by_user_id: this.user.id,
                    account_number: this.accountNumber,
                    routing_number: this.routingNumber,
                    bank_name: this.bankName,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    email_address: this.emailAddress,
                    phone: this.phone,
                    address_1: this.address1,
                    address_2: this.address2,
                    city: this.city,
                    state: this.state,
                    zip: this.zip,
                    company_name: this.company,
                    tax_classification: this.taxClassification,
                    additional_services: this.additionalServices,
                })
                .then(({ data: response, status, code}) => {
                    this.success = true;
                    this.saving = false;
                    this.$emit("save", response.data);

                    newFiles.forEach((data, index) => {
                        const formData = new FormData();
                        formData.append("attachments", data);
                        formData.append("id", response.data.id);

                        axios
                            .post("/api/upload-d2d-file", formData)
                            .then((response) => {
                                
                            });
                    });
                })
                .catch((err) => {
                    console.log(err);
                    this.saving = false;
                });
        },
        onChange(e) {
            this.files = e.target.files;
        },
        generateURL(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },
    },
};
</script>
<style scoped>
.element-fadeinout {
    opacity: 0.8;
    animation: fade 1.5s infinite;
}

.custom-file-input {
    display: none;
}

.custom-file-label {
    cursor: pointer;
    padding:.5rem.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0;
}

.custom-file-label::after {
    border-radius: 0;
}

.sign_agreement {
    font-weight: bold;
    font-size: 18px;
    color: #FF7F00;
}

/* .custom-file-label:hover {
    border-color: #80bdff;
} */

/* Optional: Add styles for when a file is selected */
/* .custom-file-input:focus +.custom-file-label,
.custom-file-input:not(:placeholder-shown) +.custom-file-label {
    border-color: #80bdff;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 0 0.2rem rgba(0,150,136,.4);
} */

@keyframes fade {
    0%,
    100% {
        opacity: 0.4;
    }
    50% {
        opacity: 0.6;
    }
}
</style>
